import React from "react";
import { Link } from "react-router-dom";

const Breadcrumb = ({ items }) => {
    return (
        <div className="page-header">
            <div className="row">
                <div className="col-sm-12">
                    <ul className="breadcrumb">
                        {items.map((item, index) => (
                            <React.Fragment key={index}>
                                <li className={`breadcrumb-item ${item.active ? "active" : ""}`}>
                                    {item.link ? <Link to={item.link}>{item.label}</Link> : item.label}
                                </li>
                                {index < items.length - 1 && (
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                )}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Breadcrumb;
